export default class RateLimitService {

  /** @ngInject **/
  constructor(
    $http,
    ngAuthSettings,
  ) {
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.serviceBaseUri = ngAuthSettings.apiServiceBaseUri;
  }

  async getRateLimitsByUser(accountId) {
    const url = this.#serviceBaseUrl(accountId);

    const limits = await this.$http.get(url);
    return limits.data;
  }

  #serviceBaseUrl(accountId) {
    return this.serviceBaseUri +  accountId + '/accountrateLimits';
  }
}